import { ChangePasswordView } from '@/features/auth/components/ChangePasswordView'

export default function ChangePasswordPage() {
  return <ChangePasswordView />
}
